import { PopupSection as OriginalComponent } from './PopupSection';

export const PopupSection = OriginalComponent;



// WEBPACK FOOTER //
// ./app/components/PopupSection/index.js